import React from 'react';
import "./csss/InformationPages.css";

export default function Greeting() {
    return (
        <div>
            <div className="container-doc">
                <div style={{fontFamily: 'Source_Sans3_bold', textAlign: "center", fontSize: "40px"}}>Анализатор оценок</div><br/>

                Этот сайт создан для того, чтобы помочь учащимся легко и наглядно отслеживать успеваемость. С помощью данного сервиса вы можете:
                <ul>
                    <li>Просматривать средние баллы по каждому предмету и в целом за период;</li>
                    <li>Сравнивать успеваемость между разными четвертями или учебными годами;</li>
                    <li>Анализировать динамику — видеть, где есть прогресс, а где требуется дополнительное внимание;</li>
                </ul>
                <div className="bold">Обратите внимание, что сайт сделан для учащихся ГБОУ Лицея №64, у других учебных заведений могут быть другие коэффициенты и разные системы выставления оценок</div>
                <br/><br/>
                Далее в документации:
                <ul>
                    <li><a href="#auth">Авторизация</a></li>
                    <li><a href="#uploadh2">Загрузка файла</a>
                        <ol>
                            <li><a href="#download">Скачивание из дневника</a></li>
                            <li><a href="#upload">Загрузка в анализатор</a></li>
                        </ol>
                    </li>
                    <li id="auth"><a href="#analyse">Состав приложения</a></li>
                    <li><a href="#questions">Возможно задаваемые вопросы</a></li>
                </ul><br/>

                <div className="h2" id="uploadh2">Авторизация</div><br/>
                <p id="download">
                    Для доступа к функциям приложения необходимо <a href="/login">войти в аккаунт</a> или <a href="/register">зарегистрироваться</a>.
                    При регистрации после заполнения данных придет на почту письмо с ссылкой на подтверждение аккаунта, после перехода по которой вы будете авторизованы
                </p><br/>
                <div className="h2">Загрузка файла</div><br/>
                <div className="h3">1. Скачивание из дневника</div><br/>
                <ol>
                    <li>Перейдите на <a href="https://dnevnik2.petersburgedu.ru/" target="_blank">сайт</a> электронного дневника "Петербургское образование"</li>
                    <li>Перейдите во вкладку "<a href="https://dnevnik2.petersburgedu.ru/estimate">Отметки</a>"</li>
                    <li id="upload">Выберите период (N-ая четверть/N-ое полугодие/Год)</li>
                    <li><span style={{display: "flex", alignItems: "center", gap: "3px"}}>Скачайте файл, нажав на иконку скачивания <i style={{fontSize: "20px"}} className="icon-arrow-up-from"></i></span></li>
                </ol><br/>

                <div className="h3" id="analyse">2. Загрузка в анализатор</div><br/>
                <p>Нажмите на кнопку "Загрузить файл"</p><br/>

                <div className="h2">Состав приложения</div><br/>
                <div className="bold">При нажатии на загруженный файл на экране появятся:</div>
                <ul>
                    <li>Список всех предметов и средних баллов по ним</li>
                    <li>Средний балл ВСЕХ оценок, среднее итоговых <span style={{fontFamily: "Source_Sans3_italic, sans-serif"}}>(то есть среднее арифметическое округленных средних баллов)</span></li>
                    <li>Количество 5, 4, 3, 2, 1, выходящих в периоде</li>
                    <li>Количество предметов, по которым не хватает оценок для аттестации (3)</li>
                    <li>Тепловая карта предметов <span style={{fontFamily: "Source_Sans3_italic, sans-serif"}}>(она показывает как изменился средний балл по каждому предмету за последние n дней)</span></li>
                    <li>Диаграмма, показывающая, сколько получено 5, 4, 3, 2, 1 за последние n дней <span style={{fontFamily: "Source_Sans3_italic, sans-serif"}}>(она появится, если нажать на стрелочку после заголовка "Тепловая карта")</span></li>
                </ul><br/>

                <div className="bold">Если нажать на предмет в списке средних баллов, то вы попадете на страницу подробного анализа успеваемости по этому предмету, в которой:</div>
                <ul>
                    <li>Текущий, минимальный, максимальный балл, количество оценок</li>
                    <li>График изменения среднего балла по предмету в течение периода</li>
                    <li>Информация про то, сколько осталось до повышения или понижения балла</li>
                    <li>Список всех полученных оценок и возможность редактировать его</li>
                </ul><br/>

                <div className="h2" id="questions">Возможно задаваемые вопросы</div><br/>
                <ul>
                    <li>
                        <div className="h4">Почему в блоке, где информация про то, сколько осталось до повышения или понижения оценки, могут быть дробные числа?</div><br/>
                        <p>Например, у тебя балл 4.42, и сайт написал, что до пятёрки осталось 2.5 пятёрки.<br/>
                        Это значит, что до пятёрки тебе достаточно получить 5 (например, за д/з) и получить 5 (например, за контрольную), потому что у д/з коэффициент 1, а у контрольной - 1.5 (1+1.5=2.5)</p><br/>
                    </li>
                    <li>
                        <div className="h4">Если текущий балл, допустим, 3.496589, то почему после округления получается 4? Ведь по правилам округления получится 3.</div><br/>
                        <div>Оценка выставляется так:
                            <ol>
                                <li>Высчитывается средний балл (3.496589)</li>
                                <li>Этот балл округляется до 2 знаков после запятой (3.50)</li>
                                <li>Учитель при выставлении видит 3.50 и выставляет в пользу ученика 4 (но бывают исключения)</li>
                            </ol>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};